import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../../Store/CouponBaseOnDomain/actions";
import { getCouponByIdAction } from "../../../../Store/Coupons/actions";
import "../../../../Assets/Scss/newHome2.scss";
import { getImageUrlhttps } from "../../../../Utils/index";
import PlaceHolderImage from "../../../../Assets/Images/PlaceholderImage.png";
import { getCouponUrlAction } from "../../../../Store/couponUrl/actions";
import CentralCouponRedirect from "../../../../Utils/CentralCouponRedirect";

function Deals({ match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );
  const { link } = useSelector((state) => state.CouponUrl);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [second, setSecond] = useState(false);
  const [useRedirectComponent, setUseRedirectComponent] = useState(false);

  const { couponByID } = useSelector((state) => state.Coupon);

  useEffect(() => {
    if (couponbaseondomainList.length === 0) {
      dispatch(getCouponsBasedOnDomainAction());
    }
  }, [couponbaseondomainList, dispatch]);

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    localStorage.setItem("link", link);
    if (redirect) {
      setNewTab(!newTab);
    }
    if (redirect2) {
      setNewTab(!newTab);
    }
  }, [link, second]);

  useEffect(() => {
    if (link && redirect) {
      setRedirect(false);
      window.open(`/meta-redirect/`, "_blank");
    }
    if (link && redirect2) {
      setRedirect2(false);
      window.open(link, "_blank");
    }
  }, [newTab]);

  return (
    <div style={{ background: "#f0f0f0" }} className="pt-0">
      <Container id="recommended-res-cards-i3">
        <div
          class="three2"
          style={{
            padding: "3vh 0 2vh 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {useRedirectComponent && (
            <CentralCouponRedirect
              e={useRedirectComponent.e}
              coupon={useRedirectComponent.coupon}
              setUseRedirectComponent={setUseRedirectComponent}
            ></CentralCouponRedirect>
          )}
          <h1 style={{ marginRight: "2%" }}>Top Deals</h1>
        </div>
        <Row>
          {couponbaseondomainList.slice(0, 20).map((coupon) => (
            <Col xl="3" sm="6">
              <>
                <div className="col" style={{ marginBottom: "8%" }}>
                  {" "}
                  <div className="card h-100 shadow-sm">
                    {" "}
                    {/*<a className="small text-muted" style={{color:"rgb(2, 137, 80)"}}>
                                  Reviews
                                </a>*/}{" "}
                    <span
                      className=" badge rounded-pill bg-success"
                      style={{
                        width: "80px",
                        position: "absolute",
                        right: "1px",
                        top: "2px",
                      }}
                    >
                      Verified
                    </span>{" "}
                    <img
                      src={getImageUrlhttps(
                        coupon.image ? coupon.image : coupon?.store?.image,
                        PlaceHolderImage
                      )}
                      loading="lazy"
                      className="card-img-top"
                      alt="..."
                      style={{
                        height: "180px",
                      }}
                    />{" "}
                    <div className="card-body">
                      {" "}
                      <div className="clearfix mb-3">
                        <span className="float-end"></span>{" "}
                      </div>{" "}
                      <h5 className="card-title" style={{ color: "gray" }}>
                        {coupon?.title}
                      </h5>{" "}
                      <div className="text-center my-4">
                        {" "}
                        <a
                          //     onClick={(e)=>{
                          //         e.stopPropagation();

                          //   dispatch(getCouponUrlAction( coupon?._id, `${window.screen.width}x${window.screen.height}`
                          //               ,`/couponsredirect/store/$store/coupon/store/${
                          //             coupon?._id
                          //           }`));

                          //           if(link){
                          //             setSecond(true); //to run useEffect even when link has not changed
                          //           }

                          // if(coupon?.redirection_type === "zero-redirect-without-refer"){
                          //     setRedirect(true);
                          // }else if(coupon?.redirection_type === "zero-redirect-with-refer"){
                          //   setRedirect2(true);
                          // }else{

                          //           localStorage.setItem("redirection_type", coupon?.redirection_type);

                          //         window.open(
                          //           `/couponsredirect/store/store/coupon/store/${
                          //             coupon?._id
                          //           }`,
                          //           "_blank"
                          //         );
                          //         }
                          //       }}

                          onClick={(e) => {
                            e.preventDefault();
                            setUseRedirectComponent({ e, coupon });
                          }}
                          className="btn btn-warning"
                          style={{
                            background: "rgb(2, 137, 80)",
                            color: "#fff",
                            borderColor: "rgb(2, 137, 80)",
                            boxShadow: "none",
                          }}
                        >
                          Check offer
                        </a>{" "}
                      </div>{" "}
                      <div className="clearfix mb-1">
                        {" "}
                        <span className="float-start">
                          <i className="far fa-question-circle" />
                        </span>{" "}
                        <span className="float-end">
                          <i className="fas fa-plus" />
                        </span>{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
              </>
            </Col>
          ))}
        </Row>
      </Container>
      <br />
    </div>
  );
}

export default Deals;
